<template>
  <el-dialog
    append-to-body
    width="600px"
    :title="`${isChange ? '修改' : '新增'}`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="name" label="学校名称">
        <!-- <el-select
          v-model="form.data.name"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in collegeOpt"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select> -->
        <el-input
          v-model="form.data.name"
          clearable
          placeholder="请输入学校名称"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item prop="campus_name" label="校区名称">
        <el-input
          v-model="form.data.campus_name"
          clearable
          placeholder="请输入校区名称"
        ></el-input>
      </el-form-item> -->
      <el-form-item prop="simple" label="学校简称">
        <el-input
          v-model="form.data.simple"
          clearable
          placeholder="如：江西财大"
        ></el-input>
      </el-form-item>
      <el-form-item prop="city" label="所在城市">
        <el-cascader
          v-model="city"
          :options="options"
          value=""
          @change="change"
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="college_type" label="学校类型">
        <el-select
          v-model="form.data.college_type"
          clearable
          multiple
          placeholder="请选择"
        >
          <el-option label="985" value="1"> </el-option>
          <el-option label="211" value="2"> </el-option>
          <el-option label="双一流" value="3"> </el-option>
          <el-option label="其他" value=""> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import common from "@/util";
export default {
  name: "SchoolEdit",
  data() {
    return {
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          simple: "", // 学校简称
          college_type: [],
          name: "",
          province: "",
          city: "",
        },
        rules: {
          name: [
            { required: true, message: "请选择学校名称", trigger: "change" },
          ],
          simple: [
            { required: true, message: "请输入学校简称", trigger: "change" },
          ],
          college_type: [
            { required: true, message: "请选择学校类型", trigger: "change" },
          ],
          city: [
            { required: true, message: "请选择所在城市", trigger: "change" },
          ],
          // campus_name: [{ required: true, message:'请输入', trigger: 'blur'}],
        },
      },
      collegeOpt: [],
      options: [],
      city: [],
    };
  },
  created() {
    this.getCollege();
    this.getall();
  },
  methods: {
    getCollege() {
      this.$http
        .get("/common/college/list", { params: { count: 10000 } })
        .then((res) => {
          if (res.code === 1) {
            this.collegeOpt = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getall() {
      this.$http.get("/common/district/all", { params: {} }).then((res) => {
        this.options = res.data.list.map((item) => {
          return {
            value: item.value,
            label: item.label,
            children: item.children
              ? item.children.map((i) => {
                  return { value: i.value, label: i.label };
                })
              : [],
          };
        });
      });
    },
    // 获取详情
    getDetail(row) {
      this.isChange = true;
      // common.deepClone(this.form.data, row);
      this.form.data = {
        id: row.id,
        // college_id: row.id,
        simple: row.simple, // 学校简称
        college_type: row.college_type ? row.college_type.split(",") : [],
        name: row.name,
        province: row.province,
        city: row.city,
      };
      this.city = [row.province, row.city];
    },
    change(e) {
      this.form.data.province = e[0];
      this.form.data.city = e[1];
    },
    reset(done) {
      this.isChange = false;
      this.form.data = {
        simple: "", // 学校简称
        college_type: [],
        name: "",
        province: "",
        city: "",
      };
      this.city = [];
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.city = [];
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let obj = {
            ...this.form.data,
            college_type: this.form.data.college_type.join(","),
          };
          // if (this.form.data.college_type == 4) {
          //   obj.college_type = "";
          // }
          this.form.loading = true;
          let apiUrl = !this.isChange
            ? "admin/college/add"
            : "admin/college/edit";
          this.$http
            .post(apiUrl, obj)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
